import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/Gallery`;

function paramsToStringList(params) {
  let stringparams = "?";
  Object.entries(params).map(([key, value]) => {
      if (value != undefined && value != null)
          stringparams = stringparams + key + "=" + value + "&";
  })
  stringparams = stringparams.substr(0, stringparams.length - 1);
  return stringparams;
}

//testttGetAllGallery
const ApiGallery = {
  getAllGallery: (params) => {
    const url = `${baseServiceUrl}/getAllGallery`;
    return ServiceApi.get(url,{params});
  },

  getSelectiveListByGalleryType: (params) => {
    const url = `${baseServiceUrl}/getSelectiveListByGalleryType`;
    return ServiceApi.get(url,{params});
  },

  getGalleryOption: () => {
    const url = `${baseServiceUrl}/getGalleryOption`;
    return ServiceApi.get(url);
  },
  
  getGalleryType: () => {
    const url = `${baseServiceUrl}/getGalleryType`;
    return ServiceApi.get(url);
  },

  createGallery: (params) => {
    const url = `${baseServiceUrl}/createGallery`;
    return ServiceApi.post(url, params );
  },

  deleteGallery: (params) => {
    const url = `${baseServiceUrl}/deleteGallery`+ paramsToStringList(params);
    return ServiceApi.delete(url, params);
  },

};

export default ApiGallery;